import { axios, axiosready } from '@/libs/api.request'

export const typeDrop = () => {
  return axiosready.request({
    url: '/course/type/ddl',
    method: 'get',
  })
}

export const list = (params) => {
  return axiosready.request({
    url: '/course/list',
    method: 'get',
    params,
  })
}

export const course = (id) => {
  return axiosready.request({
    url: `/course/detail/${id}`,
    method: 'get',
  })
}

//  创建
export const create = (data) => {
  return axios.request({
    url: '/course/create',
    method: 'post',
    data,
  })
}

//  修改
export const update = (id, data) => {
  return axios.request({
    url: `/course/update/${id}`,
    method: 'put',
    data,
  })
}

//  删除
export const remove = (id) => {
  return axios.request({
    url: `/course/delete/${id}`,
    method: 'delete',
  })
}

export const getRightsCard = (id) => {
  return axiosready.request({
    url: `/course/detail/${id}/rights_card`,
    method: 'get',
  })
}

export const getSettlementPrice = (id) => {
  return axiosready.request({
    url: `/course/detail/${id}/settlement_price`,
    method: 'get',
  })
}

export const getDefaultSettlementConfig = (id) => {
  return axiosready.request({
    url: `/course/settlement_config/${id}`,
    method: 'get',
  })
}

export const getBindCommunity = (id) => {
  return axiosready.request({
    url: `/course/detail/${id}/communities`,
    method: 'get',
  })
}

export const bindCommunity = (id, data) => {
  return axios.request({
    url: `/course/bind_community/${id}`,
    method: 'put',
    data,
  })
}

export const ddl = (params) => {
  return axiosready.request({
    url: '/course/ddl',
    method: 'get',
    params,
  })
}
